import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

interface GridSize {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
}

const defaultGridSize: GridSize = {
    xs: 12,
    sm: 6,
    md: 4,
    lg: 1.5
};

export interface Field {
    campo: string;
    valor: string | number;
    gridSize?: GridSize;
}

interface DynamicDataProps {
    fields: Field[];
}
/**
 * Componente que recibe un array de objetos con campos y valores y los muestra
 * @param param0  fields: Array de objetos con campos y valores
 * @returns   Componente con los campos y valores
 */
const DynamicData: React.FC<DynamicDataProps> = ({ fields }) => {
    return (
        <Box mb={2} sx={{ width: '100%' }}>
            <Grid container spacing={2} wrap="wrap" sx={{ width: '100%', margin: 0 }}>
                {fields.map((field, index) => (
                    <Grid
                        item
                        xs={field.gridSize?.xs ?? defaultGridSize.xs}
                        sm={field.gridSize?.sm ?? defaultGridSize.sm}
                        md={field.gridSize?.md ?? defaultGridSize.md}
                        lg={defaultGridSize.lg}
                        key={index}
                    >
                        <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#1E272E' }}>
                            {field.campo}
                        </Typography>
                        <Typography gutterBottom sx={{ color: '#3f4b59', fontSize: 13 }}>
                            {field.valor}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DynamicData;
